import React from 'react';
import Moment from 'react-moment';
import { MINIMAL_HERO } from '../../app-constants';

const CardHeader = (props) => {
  let headerContent;
  const { title, description, metaContent } = props;

  if (title) {
    headerContent = <h2 className="mb-0">{title}</h2>;
  }

  if (title && description) {
    headerContent = (
      <React.Fragment>
        <h2>{title}</h2>
        <p className="description">{description}</p>
      </React.Fragment>
    );
  }

  if (metaContent) {
    const { metaData, data } = metaContent;
    const { source, createdDate } = metaData;
    const { layoutMode } = data;
    const dateContent = <Moment format="DD MMM YYYY">{createdDate}</Moment>;

    headerContent = (
      <div className="meta">
        {layoutMode === MINIMAL_HERO ?
          <React.Fragment>
            <span className="date-span">{dateContent}</span>
            <span className="source-text-span">{source}</span>
          </React.Fragment>
          :
          <React.Fragment>
            <p className="date">{dateContent}</p>
            <p className="source-text">{source}</p>
          </React.Fragment>
        }
      </div>
    );
  }

  return (
    <div className="card-header" role="tab">
      {headerContent}
    </div>
  );
};

export default CardHeader;
